import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorComponent } from './editor.component';
import { LayoutModule} from '@progress/kendo-angular-layout';
import { ConfigurableLinkListModule } from '../../common/component/configurable_link_list/configurable_link_list.module';
import { FormsModule } from '@angular/forms';
import { NglModule} from 'ng-lightning';
//import 'ckeditor4';
import { CKEditorModule } from 'ckeditor4-angular';
import { AlertModule } from '../../common/component/alert/alert.module';
import { SpinnerModule } from '../../common/component/spinner/spinner.module';

@NgModule({
  imports: [
    CommonModule
    ,LayoutModule
    ,ConfigurableLinkListModule
    ,FormsModule
    ,NglModule
    ,CKEditorModule
    ,AlertModule
    ,SpinnerModule
  ],
  declarations: [EditorComponent],
  exports: [EditorComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class EditorModule { }
